import React, { useState, useContext, useMemo } from "react";
import { Form } from "react-final-form";
import arrayMutators from "final-form-arrays";
import { ListContext } from "context";
import { /* setQueryStringValue, */ resetQueryString } from "helpers/url";
import MainSearch, { DisplayMode } from "./MainSearch";
import GroupFilter from "./GroupFilter";

interface SearchBoxProps {
    filterProps: {
        onSubmitSuccess?: () => void;
    };
    fnameValue?: (value: any) => void;
}

const SearchBox: React.FC<SearchBoxProps> = ({ filterProps, fnameValue}) => {
    const { changeFetcherParams, data } = useContext(ListContext);
    const [show, setShow] = useState<DisplayMode>(null);

    const handleChangeMode = (mode: DisplayMode) => {
        setShow(mode);
    };

    const getFilterName = (value: any) => {
        if (!value.trim()) {
            return null;
        }

        if (fnameValue) {
            fnameValue(value);
        }
    }

    const initialValues = useMemo(() => {
        return !data?.active_filters || Array.isArray(data?.active_filters) ? {} : data.active_filters;
    }, [data]);

    return (
        <Form
            autoComplete="off"
            initialValues={initialValues}
            mutators={{ ...arrayMutators }}
            onSubmit={(values) => {
                const params = Object.assign(
                    {},
                    values,
                    {
                        autocomplete_f_famille: null,
                    },
                    {
                        per_page: data.pager.per_page,
                        page: 1,
                        order: data.pager.order || "label",
                        direction: data.pager.direction || null,
                    }
                );

                changeFetcherParams(params);
                resetQueryString();
                // Object.keys(values).forEach((filter: string) => {
                //     setQueryStringValue(filter, values[filter]);
                // });
                filterProps.onSubmitSuccess && filterProps.onSubmitSuccess();
            }}
            render={({ handleSubmit }) => {
                return (
                    <form onSubmit={handleSubmit}>
                        {/* SEARCH FIELD */}
                        <fieldset className="search-fieldset search-fieldset--open">
                            <div className="search-form-top">
                                <MainSearch changeMode={handleChangeMode} value={getFilterName} />
                            </div>

                            <GroupFilter hidden={show !== "filters"} />
                        </fieldset>
                    </form>
                );
            }}
        />
    );
};

export default SearchBox;
